import { DbMention, Mention } from './mention';
import { DbImpacterPosition, ImpacterPosition } from './impacter/impacter-position';

export interface DbReference {
  id?: number;
  name: string;
  firstname: string;
  lastname: string;
  positions: Array<DbImpacterPosition>;
  departments_uids: string[];
}

export interface Reference {
  id: string;
  name: string;
  sourceUrl?: string;
  explainUrl?: string;
  value?: string;
  positions: ImpacterPosition[];
  relevantPositions: ImpacterPosition[];
  departmentUids: string[];
  departmentUid?: string;
  articleCount?: number;
}

export class Reference {
  static nameToId(name: string): string {
    return ([...name].reduce((acc, c) => acc + c.charCodeAt(0), 0) % 10_000_000_000).toString().padStart(10, '0');
  }

  constructor(dbImpacter: DbReference, referenceDepartment?: string, articleCount?: number) {
    const positions = dbImpacter.positions.map(position => new ImpacterPosition(position));
    const activePositions = positions.filter(p => !p.isOld);
    const relevantPositions = activePositions.length ? activePositions.slice(0, 2) : positions.slice(0, 1);

    this.departmentUid = dbImpacter.departments_uids?.find(uid => uid === referenceDepartment) ?? dbImpacter.departments_uids?.[0];
    this.id = dbImpacter.id?.toString() || Reference.nameToId(dbImpacter.name);
    this.name = dbImpacter.firstname && dbImpacter.lastname ? `${dbImpacter.firstname} ${dbImpacter.lastname}` : dbImpacter.name;
    this.positions = positions;
    this.relevantPositions = relevantPositions;
    this.explainUrl = dbImpacter.id?.toString() && this.departmentUid && `/search/${this.departmentUid}/impacter/${dbImpacter.id}`;
    this.value = relevantPositions.map(p => p.role + '-' + p.territory.name).join(', ');
    this.articleCount = articleCount;
  }
}

// ContactReference

export interface DbContactReference extends DbReference {
  url?: string;
}

export interface ContactReference extends Reference {
  sourceUrl?: string;
}

export class ContactReference extends Reference {
  constructor(dbContact: DbContactReference, referenceDepartment?: string, articleCount?: number) {
    super(dbContact, referenceDepartment, articleCount);
    this.sourceUrl = dbContact.url;
  }
}

// ImpacterReference

export interface DbImpacterReference extends DbReference {
  id: number;
  mentions: DbMention[];
}

export interface ImpacterReference extends Reference {
  mentions: Mention[];
}

export class ImpacterReference extends Reference {
  constructor(dbImpacter: DbImpacterReference, referenceDepartment?: string, articleCount?: number) {
    super(dbImpacter, referenceDepartment, articleCount);
    this.mentions = dbImpacter.mentions.map(x => new Mention(x)) || [];
  }
}
